import {} from "@/api/configTemplates";
import { markup } from "@/components/ObjectStore/configurationMarkdown";
export function metadataFormEntryName(what) {
    return {
        name: "_meta_name",
        label: "Name",
        type: "text",
        optional: false,
        help: `Label this new ${what} with a name.`,
    };
}
export function metadataFormEntryDescription(what) {
    return {
        name: "_meta_description",
        label: "Description",
        optional: true,
        type: "textarea",
        help: `Provide some notes to yourself about this ${what} - perhaps to remind you how it is configured, where it stores the data, etc..`,
    };
}
export function templateVariableFormEntry(variable, variableValue) {
    var _a, _b, _c, _d, _e;
    const common_fields = {
        name: variable.name,
        label: (_a = variable.label) !== null && _a !== void 0 ? _a : variable.name,
        help: markup(variable.help || "", true),
    };
    if (variable.type == "string") {
        const defaultValue = (_b = variable.default) !== null && _b !== void 0 ? _b : "";
        return Object.assign({ type: "text", value: variableValue == undefined ? defaultValue : variableValue }, common_fields);
    }
    else if (variable.type == "path_component") {
        const defaultValue = (_c = variable.default) !== null && _c !== void 0 ? _c : "";
        // TODO: do extra validation with form somehow...
        return Object.assign({ type: "text", value: variableValue == undefined ? defaultValue : variableValue }, common_fields);
    }
    else if (variable.type == "integer") {
        const defaultValue = (_d = variable.default) !== null && _d !== void 0 ? _d : 0;
        return Object.assign({ type: "integer", value: variableValue == undefined ? defaultValue : variableValue }, common_fields);
    }
    else if (variable.type == "boolean") {
        const defaultValue = (_e = variable.default) !== null && _e !== void 0 ? _e : false;
        return Object.assign({ type: "boolean", value: variableValue == undefined ? defaultValue : variableValue }, common_fields);
    }
    else {
        throw Error("Invalid template form input type found.");
    }
}
export function templateSecretFormEntry(secret) {
    var _a;
    return {
        name: secret.name,
        label: (_a = secret.label) !== null && _a !== void 0 ? _a : secret.name,
        type: "password",
        help: markup(secret.help || "", true),
        value: "",
    };
}
export function editTemplateForm(template, what, instance) {
    var _a, _b, _c;
    const form = [];
    const nameInput = metadataFormEntryName(what);
    form.push(Object.assign({ value: (_a = instance.name) !== null && _a !== void 0 ? _a : "" }, nameInput));
    const descriptionInput = metadataFormEntryDescription(what);
    form.push(Object.assign({ value: (_b = instance.description) !== null && _b !== void 0 ? _b : "" }, descriptionInput));
    const variables = (_c = template.variables) !== null && _c !== void 0 ? _c : [];
    const variableValues = instance.variables || {};
    for (const variable of variables) {
        form.push(templateVariableFormEntry(variable, variableValues[variable.name]));
    }
    return form;
}
export function editFormDataToPayload(template, formData) {
    var _a;
    const variables = (_a = template.variables) !== null && _a !== void 0 ? _a : [];
    const name = formData["_meta_name"];
    const description = formData["_meta_description"];
    const variableData = {};
    for (const variable of variables) {
        const variableValue = formDataTypedGet(variable, formData);
        if (variableValue !== undefined) {
            variableData[variable.name] = variableValue;
        }
    }
    const payload = {
        name: name,
        description: description,
        variables: variableData,
    };
    return payload;
}
export function createTemplateForm(template, what) {
    var _a, _b;
    const form = [];
    const variables = (_a = template.variables) !== null && _a !== void 0 ? _a : [];
    const secrets = (_b = template.secrets) !== null && _b !== void 0 ? _b : [];
    form.push(metadataFormEntryName(what));
    form.push(metadataFormEntryDescription(what));
    for (const variable of variables) {
        form.push(templateVariableFormEntry(variable, undefined));
    }
    for (const secret of secrets) {
        form.push(templateSecretFormEntry(secret));
    }
    return form;
}
export function createFormDataToPayload(template, formData) {
    var _a, _b, _c;
    const variables = (_a = template.variables) !== null && _a !== void 0 ? _a : [];
    const secrets = (_b = template.secrets) !== null && _b !== void 0 ? _b : [];
    const variableData = {};
    const secretData = {};
    for (const variable of variables) {
        const variableValue = formDataTypedGet(variable, formData);
        if (variableValue !== undefined) {
            variableData[variable.name] = variableValue;
        }
    }
    for (const secret of secrets) {
        secretData[secret.name] = formData[secret.name];
    }
    const name = formData._meta_name;
    const description = formData._meta_description;
    const payload = {
        name: name,
        description: description,
        secrets: secretData,
        variables: variableData,
        template_id: template.id,
        template_version: (_c = template.version) !== null && _c !== void 0 ? _c : 0,
    };
    return payload;
}
export function formDataTypedGet(variableDefinition, formData) {
    // galaxy form library doesn't type values traditionally, so add a typed
    // access to the data if coming back as string. Though it does seem to be
    // typed properly - this might not be needed anymore?
    const variableType = variableDefinition.type;
    const variableName = variableDefinition.name;
    const rawValue = formData[variableName];
    if (variableType == "string") {
        if (rawValue == null || rawValue == undefined) {
            return undefined;
        }
        else {
            return String(rawValue);
        }
    }
    else if (variableType == "path_component") {
        if (rawValue == null || rawValue == undefined) {
            return undefined;
        }
        else {
            return String(rawValue);
        }
    }
    else if (variableType == "boolean") {
        if (rawValue == null || rawValue == undefined || typeof rawValue == "number") {
            return undefined;
        }
        else {
            return String(rawValue).toLowerCase() == "true";
        }
    }
    else if (variableType == "integer") {
        if (rawValue == null || rawValue == undefined || typeof rawValue == "boolean") {
            return undefined;
        }
        else {
            if (typeof rawValue == "string") {
                return parseInt(rawValue);
            }
            else {
                return rawValue;
            }
        }
    }
    else {
        throw Error("Unknown variable type encountered, shouldn't be possible.");
    }
}
export function upgradeForm(template, instance) {
    var _a, _b;
    const form = [];
    const variables = (_a = template.variables) !== null && _a !== void 0 ? _a : [];
    const secrets = (_b = template.secrets) !== null && _b !== void 0 ? _b : [];
    const variableValues = instance.variables || {};
    const secretsSet = instance.secrets || [];
    for (const variable of variables) {
        form.push(templateVariableFormEntry(variable, variableValues[variable.name]));
    }
    for (const secret of secrets) {
        const secretName = secret.name;
        if (secretsSet.indexOf(secretName) >= 0) {
            console.log("skipping...");
        }
        else {
            form.push(templateSecretFormEntry(secret));
        }
    }
    return form;
}
export function upgradeFormDataToPayload(template, formData) {
    var _a;
    const variables = (_a = template.variables) !== null && _a !== void 0 ? _a : [];
    const variableData = {};
    for (const variable of variables) {
        variableData[variable.name] = formData[variable.name];
    }
    const secrets = {};
    // ideally we would be able to force a template version here,
    // maybe rework backend types to force this in the API response
    // even if we don't need it in the config files
    const templateVersion = template.version || 0;
    const payload = {
        template_version: templateVersion,
        variables: variableData,
        secrets: secrets,
    };
    return payload;
}
export function pluginStatusToErrorMessage(pluginStatus) {
    var _a, _b;
    if (pluginStatus.template_definition.state == "not_ok") {
        return pluginStatus.template_definition.message;
    }
    else if (((_a = pluginStatus.template_settings) === null || _a === void 0 ? void 0 : _a.state) == "not_ok") {
        return pluginStatus.template_settings.message;
    }
    else if (((_b = pluginStatus.connection) === null || _b === void 0 ? void 0 : _b.state) == "not_ok") {
        return pluginStatus.connection.message;
    }
    return null;
}
